import { AuthenticationDetails } from 'amazon-cognito-identity-js';

// Only the verification page receives these credentials; nothing secret goes in
// router state, sessionStorage or localStorage. Reloading uses normal login.
let pendingSignup;
let nextId = 0;
export function rememberSignup(email, password) {
  const id = `${Date.now()}-${++nextId}`;
  pendingSignup = { id, email, password };
  return id;
}
export function signupCredentials(id, email) {
  return pendingSignup && pendingSignup.id === id && pendingSignup.email === email ? pendingSignup : null;
}
export function clearSignupCredentials(id) {
  if (pendingSignup?.id === id) pendingSignup = null;
}
export function matchesSignupAccount(attrs, signup) {
  if (!attrs?.sub) return false;
  return signup.signupSub ? attrs.sub === signup.signupSub
    : Boolean(signup.email && attrs.email?.toLowerCase() === signup.email.toLowerCase());
}
export const signupDestination = attrs => attrs?.['custom:userRole'] === 'photographer'
  ? '/photographer-complete-account' : '/';

export function alreadyConfirmed(error) {
  return ['NotAuthorizedException', 'InvalidParameterException'].includes(error?.code || error?.name)
    && /(?:current status is confirmed|user is already confirmed)/i.test(error?.message || '');
}
export function temporarySignInError(error) {
  return ['NetworkError', 'TimeoutError', 'InternalErrorException', 'ServiceUnavailableException'].includes(error?.code || error?.name)
    || error?.statusCode >= 500;
}

export const signupSetupErrorMessage = 'We couldn’t finish setting up your account. Retry account setup, or log in to continue.';

export function signupSetupFailed(error) {
  return ['UnexpectedLambdaException', 'UserLambdaValidationException', 'InvalidLambdaResponseException', 'CodeArtifactUserPendingException'].includes(error?.code || error?.name)
    || /postconfirmation.*(?:invocation failed|failed with error)/i.test(error?.message || '');
}

export function verificationErrorMessage(error, resend = false) {
  switch (error?.code || error?.name) {
    case 'CodeMismatchException': return 'That code doesn’t match. Check the code in your email and try again.';
    case 'ExpiredCodeException': return 'That code has expired. Request a new code and try again.';
    case 'TooManyRequestsException':
    case 'LimitExceededException': return 'There have been too many attempts. Please wait a little before trying again.';
    case 'NetworkError': return 'We couldn’t connect. Check your connection and try again.';
    default: return resend ? 'We couldn’t send a new code. Please try again shortly.' : 'We couldn’t verify your email. Please try again shortly, or contact ViewFinders if the problem continues.';
  }
}
export function authenticate(user, email, password) {
  return new Promise((resolve, reject) => {
    const additionalStep = () => reject(new Error('Automatic sign-in needs an additional authentication step. Please contact ViewFinders for help.'));
    user.authenticateUser(new AuthenticationDetails({ Username: email, Password: password }), {
      onSuccess: resolve, onFailure: reject,
      mfaRequired: additionalStep, totpRequired: additionalStep,
      mfaSetup: additionalStep, selectMFAType: additionalStep,
      newPasswordRequired: additionalStep, customChallenge: additionalStep,
    });
  });
}
